export const SET_HRES87U_INDEX_DISP = 'SET_HRES87U_INDEX_DISP'
export const GET_HRES87U_INDEX_DISP = 'GET_HRES87U_INDEX_DISP'
export const SET_HRES87U_DETAIL_DISP = 'SET_HRES87U_DETAIL_DISP'
export const GET_HRES87U_DETAIL_DISP = 'GET_HRES87U_DETAIL_DISP'
export const SET_HRES87U_MAX_ROWSPAN = 'SET_HRES87U_MAX_ROWSPAN'
export const GET_HRES87U_MAX_ROWSPAN = 'GET_HRES87U_MAX_ROWSPAN'
export const SET_HRES87U_COLUMNS = 'SET_HRES87U_COLUMNS'
export const GET_HRES87U_COLUMNS = 'GET_HRES87U_COLUMNS'
export const SET_HRES87U_LABELS = 'SET_HRES87U_LABELS'
export const GET_HRES87U_LABELS = 'GET_HRES87U_LABELS'
export const RECEIVED_HRES87U_COLUMNS_LABELS = 'RECEIVED_HRES87U_COLUMNS_LABELS'
export const SET_HRES87U_INDEX = 'SET_HRES87U_INDEX'
export const GET_HRES87U_INDEX = 'GET_HRES87U_INDEX'
export const RECEIVED_HRES87U_INDEX = 'RECEIVED_HRES87U_INDEX'
export const SET_HRES87U_INDEX_SELECTED = 'SET_HRES87U_INDEX_SELECTED'
export const GET_HRES87U_INDEX_SELECTED = 'GET_HRES87U_INDEX_SELECTED'
export const SET_HRES87U_DETAIL = 'SET_HRES87U_DETAIL'
export const GET_HRES87U_DETAIL = 'GET_HRES87U_DETAIL'
export const RECEIVED_HRES87U_DETAIL = 'RECEIVED_HRES87U_DETAIL'
export const TOGGLE_HRES87U_PAGE = 'TOGGLE_HRES87U_PAGE'
export const POST_HRES87U_SEND_APPROVE = 'POST_HRES87U_SEND_APPROVE'
export const RECEIVED_HRES87U_DROPDOWNS = 'RECEIVED_HRES87U_DROPDOWNS'
export const SET_HRES87U_DROPDOWNS = 'SET_HRES87U_DROPDOWNS'
export const GET_HRES87U_DROPDOWNS = 'GET_HRES87U_DROPDOWNS'
export const RECEIVED_HRES87U_DROPDOWNS_NUMQES = 'RECEIVED_HRES87U_DROPDOWNS_NUMQES'
export const SET_HRES87U_DROPDOWNS_NUMQES = 'SET_HRES87U_DROPDOWNS_NUMQES'
export const GET_HRES87U_DROPDOWNS_NUMQES = 'GET_HRES87U_DROPDOWNS_NUMQES'

export const SET_HRES87U_DETAIL_SUBMIT = 'SET_HRES87U_DETAIL_SUBMIT'
export const GET_HRES87U_DETAIL_SUBMIT = 'GET_HRES87U_DETAIL_SUBMIT'
export const RECEIVED_HRES87U_DETAIL_SUBMIT = 'RECEIVED_HRES87U_DETAIL_SUBMIT'



// WEBPACK FOOTER //
// ./src/store/modules/hres87u/mutation-types.js